import { combineReducers } from 'redux';
import errorReducer from './errorReducer';
import onboardingReducer from './onboardingReducer';
import signupReducer from './signupReducer';
import widgetContextReducer from './widgetContextReducer';

const rootReducer = combineReducers({
  signup: signupReducer,
  onboarding: onboardingReducer,
  error: errorReducer,
  widgetContext: widgetContextReducer,
});

export default rootReducer;
